import React from 'react';
import { Flex, Tabs, TabsProps, Tag } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import { isViewMode } from '../../constants';
import ApprovalFlowView from '../approval-flow-view';
import AxaScorecardsView from '../axa-scorecards-view';
import ExperimentDetailOverlap from '../overlapping-experiment';
import SetupForm from '../setup-form';
import { useAppNavigate } from '@/utils/navigation';

import './index.css';

const ViewModeContent = () => {
  const { navigateTo } = useAppNavigate();
  const { experimentName, action } = useParams<{
    experimentName?: string;
    action?: string;
  }>();
  const readOnly = isViewMode(action);

  if (!readOnly) {
    return null;
  }

  const currentTabName = action || 'overview';

  const items: TabsProps['items'] = [
    {
      key: '0',
      label: '',
    },
    {
      key: 'overview',
      label: 'Setup',
      children: <SetupForm />,
    },
    {
      key: 'overlap',
      label: 'Overlapping',
      children: <ExperimentDetailOverlap />,
    },
    {
      key: 'approval',
      label: 'Approval Flow',
      children: <ApprovalFlowView />,
    },
    {
      key: 'axa-scorecards',
      label: (
        <Flex align="center" gap={6}>
          AXA Scorecards
          <Tag
            color="#00b14f"
            size="xsmall"
            style={{
              color: '#fff',
              border: 'none',
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: 10,
              letterSpacing: 0.5,
            }}
          >
            New
          </Tag>
        </Flex>
      ),
      children: <AxaScorecardsView />,
    },
  ];

  return (
    <Tabs
      id="experiment-detail-tabs"
      tabBarStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 3,
        marginBottom: 0,
        background: '#fff',
      }}
      style={{ height: '100%' }}
      size="small"
      defaultActiveKey={currentTabName}
      activeKey={currentTabName}
      items={items}
      onTabClick={(key) =>
        navigateTo(`/t/experiments/${experimentName}/${key}`)
      }
    />
  );
};

export default ViewModeContent;
